class HomeVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.deferredMedia = this.querySelector('deferred-media');
    this.video = this.querySelector('video');
    this.poster = this.querySelector('.deferred-media__poster');

    if (this.deferredMedia) {
      this.setupVideoEvents();
    }
  }

  setupVideoEvents() {
    // Override the default deferred media behavior for autoplay
    if (this.deferredMedia && this.video) {
      // Force mute and hide controls
      this.video.muted = true;
      this.video.controls = false;
      this.video.autoplay = true;

      // Hide the poster immediately when video starts playing
      this.video.addEventListener('loadstart', () => {
        if (this.poster) {
          this.poster.style.display = 'none';
        }
      });

      // Ensure video plays automatically when loaded
      this.video.addEventListener('canplay', () => {
        this.video.play().catch(() => {
          // Fallback if autoplay fails
        });
      });
    }

    // Handle poster click to start video
    if (this.poster) {
      this.poster.addEventListener('click', (e) => {
        e.preventDefault();
        this.playVideo();
      });
    }
  }

  playVideo() {
    if (this.deferredMedia) {
      // Load the video content
      const template = this.deferredMedia.querySelector('template');
      if (template) {
        const content = template.content.cloneNode(true);

        // Ensure video attributes for autoplay, mute, no controls
        const video = content.querySelector('video');
        const iframe = content.querySelector('iframe');

        if (video) {
          video.muted = true;
          video.controls = false;
          video.autoplay = true;
        }

        if (iframe) {
          // Add mute and no controls parameters to iframe src
          const src = iframe.src;
          if (src.includes('youtube.com')) {
            if (!src.includes('mute=1')) {
              iframe.src = src + '&mute=1';
            }
            if (!src.includes('controls=0')) {
              iframe.src = iframe.src + '&controls=0';
            }
          } else if (src.includes('vimeo.com')) {
            if (!src.includes('muted=1')) {
              iframe.src = src + '&muted=1';
            }
            if (!src.includes('controls=0')) {
              iframe.src = iframe.src + '&controls=0';
            }
          }
        }

        this.deferredMedia.appendChild(content);
        this.deferredMedia.classList.add('loaded');

        // Hide poster
        if (this.poster) {
          this.poster.style.display = 'none';
        }
      }
    }
  }
}

// Auto-initialize when DOM is loaded
if (!customElements.get('home-video')) {
  customElements.define('home-video', HomeVideo);
}

// Initialize existing home video elements
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-video-section').forEach(section => {
    if (!section.classList.contains('initialized')) {
      new HomeVideo();
      section.classList.add('initialized');
    }
  });
});
